var map = {
	"./@demo/@module": 31688,
	"./@demo/@module.ts": 31688,
	"./@demo/demo": 21816,
	"./@demo/demo.schema": 83255,
	"./@demo/demo.schema.json": 83255,
	"./@demo/demo.ts": 21816,
	"./@demo/demoRoutes": 19132,
	"./@demo/demoRoutes.tsx": 19132,
	"./@tenants/@module": 62350,
	"./@tenants/@module.ts": 62350,
	"./@tenants/tenant.schema": 40034,
	"./@tenants/tenant.schema.json": 40034,
	"./@tenants/tenants": 19520,
	"./@tenants/tenants.ts": 19520,
	"./@tenants/tenantsRoutes": 49065,
	"./@tenants/tenantsRoutes.tsx": 49065,
	"./@users/@module": 16588,
	"./@users/@module.ts": 16588,
	"./@users/Ruoli": 4312,
	"./@users/Ruoli.tsx": 4312,
	"./@users/UsersEdit": 70799,
	"./@users/UsersEdit.tsx": 70799,
	"./@users/ruoli.schema": 72350,
	"./@users/ruoli.schema.json": 72350,
	"./@users/schema/user.edit.schema": 76006,
	"./@users/schema/user.edit.schema.json": 76006,
	"./@users/schema/user.new.schema": 31546,
	"./@users/schema/user.new.schema.json": 31546,
	"./@users/users": 3186,
	"./@users/users.tsx": 3186,
	"./@users/usersRoutes": 37575,
	"./@users/usersRoutes.tsx": 37575,
	"./accessi/AccessiGiorno": 27880,
	"./accessi/AccessiGiorno.tsx": 27880,
	"./accessi/Calendario": 97650,
	"./accessi/Calendario.tsx": 97650,
	"./accessi/accessiRoutes": 745,
	"./accessi/accessiRoutes.tsx": 745,
	"./accessi/calendario.scss": 94996,
	"./accessi/common": 49365,
	"./accessi/common.tsx": 49365,
	"./accessi/edit/accesso": 61309,
	"./accessi/edit/accesso.test": 17834,
	"./accessi/edit/accesso.test.tsx": 17834,
	"./accessi/edit/accesso.tsx": 61309,
	"./accessi/gql/calendario": 26745,
	"./accessi/gql/calendario.accesso": 84026,
	"./accessi/gql/calendario.accesso.ts": 84026,
	"./accessi/gql/calendario.ts": 26745,
	"./accessi/schema/edit/accessoDiretto.annullamento": 55612,
	"./accessi/schema/edit/accessoDiretto.annullamento.json": 55612,
	"./accessi/schema/edit/accessoDiretto.erogazione": 50051,
	"./accessi/schema/edit/accessoDiretto.erogazione.json": 50051,
	"./accessi/schema/edit/accessoErogato": 84807,
	"./accessi/schema/edit/accessoErogato.ts": 84807,
	"./accessi/schema/edit/accessoPianificato": 88888,
	"./accessi/schema/edit/accessoPianificato.ts": 88888,
	"./accessi/schema/edit/nuovoAccesso": 89017,
	"./accessi/schema/edit/nuovoAccesso.json": 89017,
	"./accessi/schema/filters/calendario": 48445,
	"./accessi/schema/filters/calendario.json": 48445,
	"./anagrafiche/@module": 68505,
	"./anagrafiche/@module.ts": 68505,
	"./anagrafiche/allegati": 98495,
	"./anagrafiche/allegati.ts": 98495,
	"./anagrafiche/anagraficheRoutes": 3601,
	"./anagrafiche/anagraficheRoutes.tsx": 3601,
	"./anagrafiche/assistiti": 18956,
	"./anagrafiche/assistiti.tsx": 18956,
	"./anagrafiche/common": 97462,
	"./anagrafiche/common.ts": 97462,
	"./anagrafiche/contratti": 93229,
	"./anagrafiche/contratti.ts": 93229,
	"./anagrafiche/editAssistito": 9205,
	"./anagrafiche/editAssistito.tsx": 9205,
	"./anagrafiche/editMedico": 13250,
	"./anagrafiche/editMedico.tsx": 13250,
	"./anagrafiche/editOperatore": 50927,
	"./anagrafiche/editOperatore.tsx": 50927,
	"./anagrafiche/gql/anagrafica": 23189,
	"./anagrafiche/gql/anagrafica.ts": 23189,
	"./anagrafiche/gql/assistiti": 31112,
	"./anagrafiche/gql/assistiti.ts": 31112,
	"./anagrafiche/gql/medici": 95826,
	"./anagrafiche/gql/medici.ts": 95826,
	"./anagrafiche/gql/operatori": 34098,
	"./anagrafiche/gql/operatori.ts": 34098,
	"./anagrafiche/medici": 94756,
	"./anagrafiche/medici.tsx": 94756,
	"./anagrafiche/operatori": 89687,
	"./anagrafiche/operatori.tsx": 89687,
	"./anagrafiche/schema/_OLD_/anagrafica": 12514,
	"./anagrafiche/schema/_OLD_/anagrafica-assistiti": 64630,
	"./anagrafiche/schema/_OLD_/anagrafica-assistiti.json": 64630,
	"./anagrafiche/schema/_OLD_/anagrafica.json": 12514,
	"./anagrafiche/schema/_OLD_/assistito": 48907,
	"./anagrafiche/schema/_OLD_/assistito.json": 48907,
	"./anagrafiche/schema/_OLD_/contatti": 40198,
	"./anagrafiche/schema/_OLD_/contatti.json": 40198,
	"./anagrafiche/schema/_OLD_/erogatore": 61249,
	"./anagrafiche/schema/_OLD_/erogatore.json": 61249,
	"./anagrafiche/schema/_OLD_/medico": 87680,
	"./anagrafiche/schema/_OLD_/medico.json": 87680,
	"./anagrafiche/schema/_OLD_/operatore": 93780,
	"./anagrafiche/schema/_OLD_/operatore.json": 93780,
	"./anagrafiche/schema/_OLD_/sanita": 47155,
	"./anagrafiche/schema/_OLD_/sanita.json": 47155,
	"./anagrafiche/schema/_OLD_/studiolavoro-assistiti": 22802,
	"./anagrafiche/schema/_OLD_/studiolavoro-assistiti.json": 22802,
	"./anagrafiche/schema/_OLD_/studiolavoro-medici": 34354,
	"./anagrafiche/schema/_OLD_/studiolavoro-medici.json": 34354,
	"./anagrafiche/schema/_OLD_/studiolavoro-operatore": 55144,
	"./anagrafiche/schema/_OLD_/studiolavoro-operatore.json": 55144,
	"./anagrafiche/schema/_OLD_/sub/allegato": 77965,
	"./anagrafiche/schema/_OLD_/sub/allegato.json": 77965,
	"./anagrafiche/schema/_OLD_/sub/cittadinanza": 82330,
	"./anagrafiche/schema/_OLD_/sub/cittadinanza.json": 82330,
	"./anagrafiche/schema/_OLD_/sub/contratto": 80369,
	"./anagrafiche/schema/_OLD_/sub/contratto.json": 80369,
	"./anagrafiche/schema/_OLD_/sub/documento": 89813,
	"./anagrafiche/schema/_OLD_/sub/documento.json": 89813,
	"./anagrafiche/schema/_OLD_/sub/recapito": 81240,
	"./anagrafiche/schema/_OLD_/sub/recapito.json": 81240,
	"./anagrafiche/schema/_OLD_/sub/sede": 44470,
	"./anagrafiche/schema/_OLD_/sub/sede.json": 44470,
	"./anagrafiche/schema/_OLD_/sub/tesseraSanitaria": 92289,
	"./anagrafiche/schema/_OLD_/sub/tesseraSanitaria.json": 92289,
	"./anagrafiche/schema/filters/anagrafica": 47599,
	"./anagrafiche/schema/filters/anagrafica.json": 47599,
	"./anagrafiche/sub/Cittadinanza": 71886,
	"./anagrafiche/sub/Cittadinanza.tsx": 71886,
	"./anagrafiche/sub/DocumentiIdentita": 14698,
	"./anagrafiche/sub/DocumentiIdentita.tsx": 14698,
	"./anagrafiche/sub/Domicili": 67460,
	"./anagrafiche/sub/Domicili.tsx": 67460,
	"./anagrafiche/sub/Recapiti": 23261,
	"./anagrafiche/sub/Recapiti.tsx": 23261,
	"./anagrafiche/sub/Sedi": 52533,
	"./anagrafiche/sub/Sedi.tsx": 52533,
	"./anagrafiche/sub/TessereSanitarie": 45498,
	"./anagrafiche/sub/TessereSanitarie.tsx": 45498,
	"./cartelle/@module": 23911,
	"./cartelle/@module.ts": 23911,
	"./cartelle/CartellaDettaglio": 81997,
	"./cartelle/CartellaDettaglio.tsx": 81997,
	"./cartelle/Dimissioni": 22328,
	"./cartelle/Dimissioni.tsx": 22328,
	"./cartelle/NuovaCartella": 13762,
	"./cartelle/NuovaCartella.tsx": 13762,
	"./cartelle/SchedaPresaInCarico": 2592,
	"./cartelle/SchedaPresaInCarico.tsx": 2592,
	"./cartelle/___Sospensione": 91019,
	"./cartelle/___Sospensione.tsx": 91019,
	"./cartelle/affidamenti": 82255,
	"./cartelle/affidamenti.ts": 82255,
	"./cartelle/cartelle": 36781,
	"./cartelle/cartelle.ts": 36781,
	"./cartelle/cartelleRoutes": 15103,
	"./cartelle/cartelleRoutes.tsx": 15103,
	"./cartelle/diario": 70610,
	"./cartelle/diario.ts": 70610,
	"./cartelle/edit/affidamento": 69807,
	"./cartelle/edit/affidamento.tsx": 69807,
	"./cartelle/edit/progetto": 79337,
	"./cartelle/edit/progetto.tsx": 79337,
	"./cartelle/edit/valutazione": 16264,
	"./cartelle/edit/valutazione.tsx": 16264,
	"./cartelle/gql/accessoDiretto": 59837,
	"./cartelle/gql/accessoDiretto.ts": 59837,
	"./cartelle/gql/affidamento": 57481,
	"./cartelle/gql/affidamento.ts": 57481,
	"./cartelle/gql/cartella": 21957,
	"./cartelle/gql/cartella.ts": 21957,
	"./cartelle/gql/dimissione": 35711,
	"./cartelle/gql/dimissione.ts": 35711,
	"./cartelle/gql/intervento": 84584,
	"./cartelle/gql/intervento.ts": 84584,
	"./cartelle/gql/presaInCarico": 91807,
	"./cartelle/gql/presaInCarico.ts": 91807,
	"./cartelle/gql/progettoPai": 80657,
	"./cartelle/gql/progettoPai.ts": 80657,
	"./cartelle/gql/sospensione": 65898,
	"./cartelle/gql/sospensione.ts": 65898,
	"./cartelle/gql/valutazione": 12480,
	"./cartelle/gql/valutazione.ts": 12480,
	"./cartelle/gql/voceDiario": 82473,
	"./cartelle/gql/voceDiario.ts": 82473,
	"./cartelle/progetti": 3859,
	"./cartelle/progetti.ts": 3859,
	"./cartelle/schema/edit/accessoDiretto": 63205,
	"./cartelle/schema/edit/accessoDiretto.ts": 63205,
	"./cartelle/schema/edit/affidamento": 47753,
	"./cartelle/schema/edit/affidamento.json": 47753,
	"./cartelle/schema/edit/dimissioni": 63,
	"./cartelle/schema/edit/dimissioni.json": 63,
	"./cartelle/schema/edit/nuova.cartella.schema": 55757,
	"./cartelle/schema/edit/nuova.cartella.schema.json": 55757,
	"./cartelle/schema/edit/pai": 17971,
	"./cartelle/schema/edit/pai.json": 17971,
	"./cartelle/schema/edit/pianoAssistenziale": 18664,
	"./cartelle/schema/edit/pianoAssistenziale.json": 18664,
	"./cartelle/schema/edit/pianoAssistenzialePrestazione": 46828,
	"./cartelle/schema/edit/pianoAssistenzialePrestazione.json": 46828,
	"./cartelle/schema/edit/presaInCarico": 37945,
	"./cartelle/schema/edit/presaInCarico.json": 37945,
	"./cartelle/schema/edit/progetto": 94086,
	"./cartelle/schema/edit/progetto.json": 94086,
	"./cartelle/schema/edit/sospensione": 78216,
	"./cartelle/schema/edit/sospensione.ts": 78216,
	"./cartelle/schema/edit/valutazione": 50415,
	"./cartelle/schema/edit/valutazione.ts": 50415,
	"./cartelle/schema/edit/voceDiario": 94784,
	"./cartelle/schema/edit/voceDiario.json": 94784,
	"./cartelle/schema/filters/affidamenti": 64421,
	"./cartelle/schema/filters/affidamenti.json": 64421,
	"./cartelle/schema/filters/cartelle": 57477,
	"./cartelle/schema/filters/cartelle.json": 57477,
	"./cartelle/schema/filters/progetti": 11754,
	"./cartelle/schema/filters/progetti.json": 11754,
	"./cartelle/sgdt/AuthFlow": 62721,
	"./cartelle/sgdt/AuthFlow.tsx": 62721,
	"./cartelle/sgdt/SGDT": 57893,
	"./cartelle/sgdt/SGDT.tsx": 57893,
	"./cartelle/sgdt/sgdt": 73603,
	"./cartelle/sgdt/sgdt.ts": 73603,
	"./cartelle/sub/Affidamento": 23363,
	"./cartelle/sub/Affidamento.tsx": 23363,
	"./cartelle/sub/PianoAssistenziale": 23137,
	"./cartelle/sub/PianoAssistenziale.tsx": 23137,
	"./cartelle/sub/___pianoAssistenziale": 23199,
	"./cartelle/sub/___pianoAssistenziale.ts": 23199,
	"./cartelle/sub/accessiDiretti": 4945,
	"./cartelle/sub/accessiDiretti.tsx": 4945,
	"./cartelle/sub/sospensioni": 83121,
	"./cartelle/sub/sospensioni.ts": 83121,
	"./cartelle/sub/valutazioni": 99495,
	"./cartelle/sub/valutazioni.ts": 99495,
	"./cartelle/view/accessoDiretto": 98722,
	"./cartelle/view/accessoDiretto.tsx": 98722,
	"./commons/GestioneListe": 53906,
	"./commons/GestioneListe.tsx": 53906,
	"./commons/collapsable-menu": 29003,
	"./commons/collapsable-menu.jsx": 29003,
	"./commons/filterTable": 88843,
	"./commons/filterTable.jsx": 88843,
	"./commons/schema/lista": 64994,
	"./commons/schema/lista.json": 64994,
	"./config/accountOperatori/@module": 43570,
	"./config/accountOperatori/@module.ts": 43570,
	"./config/accountOperatori/List": 72280,
	"./config/accountOperatori/List.tsx": 72280,
	"./config/accountOperatori/collega.schema": 8217,
	"./config/accountOperatori/collega.schema.json": 8217,
	"./config/accountOperatori/collegaOperatore": 34681,
	"./config/accountOperatori/collegaOperatore.tsx": 34681,
	"./config/accountOperatori/nuovoOperatore.schema": 41066,
	"./config/accountOperatori/nuovoOperatore.schema.json": 41066,
	"./config/accounts/dettaglio-popup": 28161,
	"./config/accounts/dettaglio-popup.jsx": 28161,
	"./config/accounts/list": 47828,
	"./config/accounts/list.jsx": 47828,
	"./config/configRoutes": 56108,
	"./config/configRoutes.tsx": 56108,
	"./config/lists/ListsManagement": 65477,
	"./config/lists/ListsManagement.tsx": 65477,
	"./config/permissions/add-permission-popup": 38621,
	"./config/permissions/add-permission-popup.jsx": 38621,
	"./config/permissions/groups": 43568,
	"./config/permissions/groups.jsx": 43568,
	"./config/permissions/list": 98634,
	"./config/permissions/list.jsx": 98634,
	"./config/permissions/main": 83753,
	"./config/permissions/main.jsx": 83753,
	"./config/permissions/remove-permission-popup": 26603,
	"./config/permissions/remove-permission-popup.jsx": 26603,
	"./config/roles/detail": 43665,
	"./config/roles/detail.jsx": 43665,
	"./config/roles/list": 2269,
	"./config/roles/list.jsx": 2269,
	"./dashboard/admin/DashboardAdmin": 98651,
	"./dashboard/admin/DashboardAdmin.jsx": 98651,
	"./dashboard/admin/components/ApiLineChart": 72183,
	"./dashboard/admin/components/ApiLineChart.jsx": 72183,
	"./dashboard/admin/components/ApiPieChart": 71521,
	"./dashboard/admin/components/ApiPieChart.jsx": 71521,
	"./dashboard/admin/components/BandwidthLineChart": 94490,
	"./dashboard/admin/components/BandwidthLineChart.jsx": 94490,
	"./dashboard/admin/components/BandwidthPieChart": 97838,
	"./dashboard/admin/components/BandwidthPieChart.jsx": 97838,
	"./dashboard/dashboardRoutes": 52290,
	"./dashboard/dashboardRoutes.tsx": 52290,
	"./dashboard/supervisor/DashboardSupervisor": 69613,
	"./dashboard/supervisor/DashboardSupervisor.jsx": 69613,
	"./dashboard/supervisor/components/AccessiPianificati": 92524,
	"./dashboard/supervisor/components/AccessiPianificati.tsx": 92524,
	"./dashboard/supervisor/components/BudgetChart": 47931,
	"./dashboard/supervisor/components/BudgetChart.jsx": 47931,
	"./dashboard/supervisor/components/NotificationsCard": 41338,
	"./dashboard/supervisor/components/NotificationsCard.jsx": 41338,
	"./dashboard/supervisor/components/NuoveCartelle": 57275,
	"./dashboard/supervisor/components/NuoveCartelle.tsx": 57275,
	"./dashboard/supervisor/components/ProgettiInScadenza": 34069,
	"./dashboard/supervisor/components/ProgettiInScadenza.tsx": 34069,
	"./dashboard/supervisor/components/ProjectsChart": 65216,
	"./dashboard/supervisor/components/ProjectsChart.tsx": 65216,
	"./dashboard/supervisor/components/TableWidget": 27093,
	"./dashboard/supervisor/components/TableWidget.tsx": 27093,
	"./dashboard/supervisor/components/TaskManagerList": 7879,
	"./dashboard/supervisor/components/TaskManagerList.jsx": 7879,
	"./dashboard/users/DashboardUsers": 95263,
	"./dashboard/users/DashboardUsers.jsx": 95263,
	"./dashboard/users/components/NotificationsCard": 74709,
	"./dashboard/users/components/NotificationsCard.jsx": 74709,
	"./dashboard/users/components/TaskManagerList": 63149,
	"./dashboard/users/components/TaskManagerList.jsx": 63149,
	"./form-samples/form1.jsx.bk": 40796,
	"./form-samples/formSamplesRoutes.tsx.bk": 30144,
	"./icons/AppIcon": 64676,
	"./icons/AppIcon.jsx": 64676,
	"./icons/iconsMind": 73540,
	"./icons/iconsMind.js": 73540,
	"./icons/iconsRoutes": 26550,
	"./icons/iconsRoutes.tsx": 26550,
	"./progetti/calendar/AppCalendar": 99752,
	"./progetti/calendar/AppCalendar.jsx": 99752,
	"./progetti/calendar/CalendarEventDialog": 47361,
	"./progetti/calendar/CalendarEventDialog.jsx": 47361,
	"./progetti/calendar/CalendarService": 99632,
	"./progetti/calendar/CalendarService.js": 99632,
	"./progetti/calendar/calendar-events": 69121,
	"./progetti/calendar/calendar-events.js": 69121,
	"./progetti/calendar/calendarRoutes": 56205,
	"./progetti/calendar/calendarRoutes.js": 56205,
	"./progetti/calendar/schema-evento": 78471,
	"./progetti/calendar/schema-evento.json": 78471,
	"./progetti/dettaglio-progetto": 7741,
	"./progetti/dettaglio-progetto.jsx": 7741,
	"./progetti/dettaglio-titolo": 82028,
	"./progetti/dettaglio-titolo.jsx": 82028,
	"./progetti/progettiRoutes": 88743,
	"./progetti/progettiRoutes.tsx": 88743,
	"./progetti/schema-progetto": 61175,
	"./progetti/schema-progetto.json": 61175,
	"./progetti/schema-titolo": 3676,
	"./progetti/schema-titolo.json": 3676,
	"./reports/Reports": 67086,
	"./reports/Reports.tsx": 67086,
	"./reports/reportsRoutes": 3299,
	"./reports/reportsRoutes.tsx": 3299,
	"./reports/schema/filters.schema": 84835,
	"./reports/schema/filters.schema.json": 84835,
	"./strutture-servizi/@module": 35753,
	"./strutture-servizi/@module.ts": 35753,
	"./strutture-servizi/edit/erogatore": 24354,
	"./strutture-servizi/edit/erogatore.tsx": 24354,
	"./strutture-servizi/edit/prestazione": 28684,
	"./strutture-servizi/edit/prestazione.tsx": 28684,
	"./strutture-servizi/edit/servizio": 97285,
	"./strutture-servizi/edit/servizio.tsx": 97285,
	"./strutture-servizi/erogatori": 97881,
	"./strutture-servizi/erogatori.tsx": 97881,
	"./strutture-servizi/gql/erogatori": 80127,
	"./strutture-servizi/gql/erogatori.ts": 80127,
	"./strutture-servizi/gql/prestazioni": 56966,
	"./strutture-servizi/gql/prestazioni.ts": 56966,
	"./strutture-servizi/gql/servizi": 78160,
	"./strutture-servizi/gql/servizi.ts": 78160,
	"./strutture-servizi/gql/strutturaSanitaria": 71773,
	"./strutture-servizi/gql/strutturaSanitaria.ts": 71773,
	"./strutture-servizi/percorsi": 54033,
	"./strutture-servizi/percorsi.ts": 54033,
	"./strutture-servizi/prestazioni": 51624,
	"./strutture-servizi/prestazioni.tsx": 51624,
	"./strutture-servizi/schema/edit/percorso": 19262,
	"./strutture-servizi/schema/edit/percorso.json": 19262,
	"./strutture-servizi/schema/edit/prestazione": 72926,
	"./strutture-servizi/schema/edit/prestazione.json": 72926,
	"./strutture-servizi/schema/edit/servizio": 60257,
	"./strutture-servizi/schema/edit/servizio.json": 60257,
	"./strutture-servizi/schema/edit/strutturaSanitaria": 93653,
	"./strutture-servizi/schema/edit/strutturaSanitaria.json": 93653,
	"./strutture-servizi/servizi": 79872,
	"./strutture-servizi/servizi.tsx": 79872,
	"./strutture-servizi/struttureSanitarie": 57261,
	"./strutture-servizi/struttureSanitarie.ts": 57261,
	"./strutture-servizi/struttureServiziRoutes": 29343,
	"./strutture-servizi/struttureServiziRoutes.tsx": 29343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62142;